import RouteObject from './RouteObject';
var routes = {
    ROOT: new RouteObject('/', false, false, false, true),
    LOGIN: new RouteObject('/login', false),
    CONFIRM_REGISTRATION: new RouteObject('/confirm-registration', false),
    ACCEPT_INVITE: new RouteObject('/accept-invite', false),
    FORGOT_PASSWORD: new RouteObject('/forgot-password', false),
    RESET_PASSWORD: new RouteObject('/reset-password', false),
    CREATE_ACCOUNT: new RouteObject('/create-account', false),
    DELETE_ACCOUNT: new RouteObject('/delete-account', false),
    ON_BOARDING: new RouteObject('/on-boarding', true),
    DASHBOARD: new RouteObject('/dashboard', true),
    ASSETS: new RouteObject('/assets', true),
    ASSETS_ARCHIVED: new RouteObject('/archived-assets', true),
    FEEDS: new RouteObject('/feeds', true),
    FEEDS_ADD: new RouteObject('/feeds/add', true),
    FEED_EDIT: new RouteObject('/feeds/:id', true),
    DEVICES: new RouteObject('/devices', true),
    DEVICES_ADD: new RouteObject('/devices/add', true),
    LABELS: new RouteObject('/labels', true),
    USERS: new RouteObject('/users', true),
    ADD_USER: new RouteObject('/users/add', true),
    EDIT_USER: new RouteObject('/users/:id', true),
    SERVICE: new RouteObject('/service', true),
    SERVICE_SCHEMAS: new RouteObject('/service/schemas', true),
    SERVICE_SCHEMAS_ADD: new RouteObject('/service/schemas/add', true),
    SERVICE_SCHEMAS_EDIT: new RouteObject('/service/schemas/:id', true),
    SERVICE_ENTRIES: new RouteObject('/service/entries', true),
    SERVICE_ENTRIES_CLOSED: new RouteObject('/service/entries/closed', true),
    REPORTS: new RouteObject('/reports', true),
    METRICS: new RouteObject('/metrics', true),
    PROFILE: new RouteObject('/profile', true),
};
export default routes;
